var map = {
	"./abughazi.avif": 667,
	"./alex-bonuses.png": 8633,
	"./austinski.avif": 1989,
	"./awake.avif": 6713,
	"./ballyboy.avif": 1408,
	"./bcdegens.avif": 2205,
	"./betgemzz.avif": 2592,
	"./booth.avif": 5946,
	"./chilislots.avif": 3692,
	"./chuckauee.avif": 3362,
	"./cleanswipe.avif": 7319,
	"./fugroo.avif": 9496,
	"./gabbidoto.avif": 1433,
	"./hanvee.avif": 9343,
	"./kaneyy.avif": 8605,
	"./kicksword.png": 134,
	"./maherco.avif": 1014,
	"./mikhailis.avif": 743,
	"./moonlight.avif": 5089,
	"./mrchocolate.avif": 2597,
	"./mysticbert.avif": 4444,
	"./pezslaps.avif": 7924,
	"./romieinc.avif": 2874,
	"./seham1.avif": 6263,
	"./setokaiba.avif": 9783,
	"./slotden.avif": 1969,
	"./stilltre.avif": 9749,
	"./tslots.avif": 6627,
	"./twinslots.avif": 1901,
	"./twixa.avif": 4777,
	"./vivstream.avif": 903,
	"./wiema.png": 3428,
	"./winfest.png": 7679,
	"./zingosquad.avif": 105
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6247;